import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {formatCurrency, handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import {getInventoryEvent, getInventoryMemberships} from "../common/api/InventoryApi";
import {Chip, Divider, Grid} from "@mui/material";
import {clientAddToCart} from "../common/api/CartApi";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import Avatar from "@mui/material/Avatar";
import {People} from "@mui/icons-material";
import ViewInventoryModal from "./ViewInventoryModal";
import ToggleDetails from "../common/ToggleDetail";
import MembershipPerks from "../perks/MembershipPerks";

export default function ClientInventoryPanel(props) {
  const [context, setContext] = useContext(AppContext);

  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [memberships, setMemberships] = useState([]);

  useEffect(() => {
    getInventoryMembershipsFn()
  }, []);

  const [inventory, setInventory] = useState();
  const [showMembershipModal, setShowMembershipModal] = useState(false);
  const [savingMembership, setSavingMembership] = useState(false);
  const [siblingRenderIndex, setSiblingRenderIndex] = useState(1);

  const getInventoryEventFn = async (eventId) => {
    getInventoryEvent(eventId).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEvent(result);
        setEventReady(true);
      }
    });
  }

  const [inventoryType, setInventoryType] = useState();
  const [formInvalid, setFormInvalid] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const handleClose = () => {
    setShowMembershipModal(false);
  };

  const handleSave = (data) => {
    props.handleSave(data);
  };

  const getInventoryMembershipsFn = async () => {
    let result = await getInventoryMemberships();
    setMemberships(result);
  }

  const loadCartFn = () => {

    let _context = {...context};
    _context.reloadCart = true;
    _context.toast = {
      message: 'Added to cart!',
      type: 'success'
    }
    setContext({..._context});
  };

  // {showInventoryModal && <ViewInventoryModal
  //               handleClose={() => {
  //                 setShowInventoryModal(false);
  //               }}
  //               handleSave={(item) => {
  //                 sendToCartFn(item);
  //                 setShowInventoryModal(false);
  //               }}
  //               show={showInventoryModal}
  //               inventory={inventory}
  //             />}

  const [showInventoryModal, setShowInventoryModal] = useState(false);

  const sendToCartFn = (item) =>{
    clientAddToCart(inventory, props?.client?.guid).then(resp => {
      props.onSave();
    });
  }

  const viewInventoryFn = (inventory) => {
    setInventory(inventory);
    setShowInventoryModal(true);
  }

  const addToCartFn = async (inventory) => {
    viewInventoryFn(inventory);
    return;
    clientAddToCart(inventory, props?.client?.guid).then(resp => {
      props.onSave();
    });
  };

  return (
    <>
      <MDBox p={3}>
        <MDBox>
          {memberships?.length > 0 && <>
            {memberships?.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
              // .filter(item => showEvent(item))
              .map((inventory, index) => {
                return (
                  <div key={index}>
                    <Grid container spacing={3}>
                      <Grid item xs={1} sm={2}>
                        <MDBox display="flex" justifyContent="flex-center">

                          <Avatar alt={inventory?.name}
                                  sx={{width: '90%', height: 'auto'}}>
                            {inventory?.imageUrl && <img src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                                         style={{width: '100%', height: 'auto'}}
                                                         alt={inventory?.name}/>}
                          </Avatar>

                        </MDBox>
                      </Grid>
                      <Grid item xs={11} sm={7}>
                        <h6>{inventory.name}</h6>
                        <p><small>
                          {inventory.accountType?.name}
                        </small><br/>
                          <small>
                            {formatCurrency(inventory?.price)}
                          </small>
                        </p>

                        <ToggleDetails limit={15} text={inventory?.desc} />

                        <div>
                          <MDBox mt={1}>
                            {inventory?.accountType?.recurring &&
                              <><Chip
                                label="Recurring"
                                variant="outlined"
                                className={'my-1'}
                                color="secondary"/>&nbsp;
                              </>
                            }
                            {inventory?.accountType?.unlimitedVisits &&
                              <><Chip
                                label="Unlimited Visits"
                                variant="outlined"
                                className={'my-1'}
                                color="secondary"/>
                                &nbsp;
                              </>
                            }
                            {inventory?.siblingMembership && <><Chip
                              icon={<People />}
                              label={'Sibling Rate ' + formatCurrency(inventory?.siblingMembership?.price)}
                              variant="outlined"
                              className={'my-1'}
                              style={{
                                background:'#fff'
                              }}
                              color="secondary"/>
                              &nbsp;
                            </>}
                          </MDBox>

                          <MembershipPerks inventory={inventory} />

                        </div>
                      </Grid>


                      <Grid item xs={12} sm={3} justifyContent="flex-end" alignItems="flex-end" sx={{ position: 'relative' }}>

                        {
                          <MDBox display="flex" justifyContent="flex-end" alignItems="flex-end">
                            <MDButton
                              style={{
                                position:'absolute',
                                bottom:'10px'
                              }}
                                      size={'small'}
                                      color="secondary"
                                      onClick={(e) => {
                                        addToCartFn(inventory);
                                      }}>View</MDButton>
                          </MDBox>
                        }
                      </Grid>
                    </Grid>

                    <Divider/>
                  </div>
                )
              })
            }
          </>}
        </MDBox>
      </MDBox>

      {showInventoryModal && <ViewInventoryModal
        handleClose={() => {
          setShowInventoryModal(false);
        }}
        handleSave={(item) => {
          sendToCartFn(item);
          setShowInventoryModal(false);
        }}
        show={showInventoryModal}
        inventory={inventory}
      />}
    </>
  )
}